<template>
  <span>
    {{ dateTime ? displayDateTime: _displayDate }}<i ref="dateRef" class="fa fa-question-circle ml-2" tabindex="0"></i>
    <b-tooltip :target="() => dateRef" placement="auto" triggers="hover focus">
      <span>{{ `${displayDateTimeUTC_Tooltip}\n converted to your local time \n${displayDateTime_Tooltip}` }}</span>
    </b-tooltip>
  </span>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      required: true,
    },
    dateTime: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dateRef: null,
      dateOptions: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      dateTimeOptions: {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      },
      tooltipOptions: {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZoneName: "short",
      },
    }
  },
  mounted() {
    this.dateRef = this.$refs.dateRef
  },
  computed: {
    _displayDate() {
      return this.getLocalDateTime(this.dateOptions)
    },
    displayDateTime() {
      return this.getLocalDateTime(this.dateTimeOptions)
    },
    displayDateTime_Tooltip() {
      return this.getLocalDateTime(this.tooltipOptions)
    },
    displayDateTimeUTC_Tooltip() {
      return this.getLocalDateTime(this.tooltipOptions, false)
    },
  },
  methods: {
    getLocalDateTime(options, local = true) {
      if (!local) {
        options = {...options, timeZone: "UTC"}
      }
      return new Intl.DateTimeFormat("default", options).format(new Date(this.date))
    },
  },
};
</script>

<style scoped></style>
